/**
 * Kopstorm 24 Sep 2026 - screen reader fixes (ADA complaint, May 2026 findings)
 * 1. The selected Kaching bundle is announced, and every bundle option has an accessible name.
 * 2. Adding to cart is announced ("Added to cart" plus the product) when the cart drawer opens.
 * 3. Plus and minus quantity buttons rendered by apps get a label (theme ones have it in Liquid).
 * Strike through prices are handled in Liquid (visually hidden "Regular price" / "Sale price") and,
 * for the Kaching bars, in kopstorm.css.
 */
(function () {
  'use strict';

  var text = window.kopA11yText || {};

  function region() {
    var el = document.getElementById('kop-a11y-status');
    if (!el) {
      el = document.createElement('div');
      el.id = 'kop-a11y-status';
      el.className = 'visually-hidden';
      el.setAttribute('role', 'status');
      el.setAttribute('aria-live', 'polite');
      el.setAttribute('aria-atomic', 'true');
      document.body.appendChild(el);
    }
    return el;
  }

  function announce(message, delay) {
    if (!message) return;
    var el = region();
    el.textContent = '';
    setTimeout(function () { el.textContent = message; }, delay || 120);
  }

  function clean(value) {
    return (value || '').replace(/\s+/g, ' ').trim();
  }

  /* 1. Kaching bundle options */
  function barName(bar) {
    if (!bar) return '';
    var title = bar.querySelector('.kaching-bundles__bar-title, [class*="bar-title"]');
    return clean(title ? title.textContent : bar.textContent).slice(0, 120);
  }

  function labelKaching(root) {
    (root || document).querySelectorAll('.kaching-bundles__bar-radio').forEach(function (radio) {
      if (radio.getAttribute('aria-label') || radio.closest('label')) return;
      var name = barName(radio.closest('.kaching-bundles__bar'));
      if (name) radio.setAttribute('aria-label', name);
    });
  }

  document.addEventListener('change', function (event) {
    var input = event.target;
    if (!input || !input.closest || !input.closest('.kaching-bundles')) return;
    if (input.type === 'radio' && input.checked) {
      var name = input.getAttribute('aria-label') || barName(input.closest('.kaching-bundles__bar'));
      if (name) announce(name + ', ' + (text.selected || 'selected'));
    } else if (input.tagName === 'SELECT') {
      var option = input.options[input.selectedIndex];
      if (option) announce(clean(option.textContent) + ', ' + (text.selected || 'selected'));
    }
  });

  /* 3. Quantity buttons injected by apps */
  function labelQuantity(root) {
    (root || document).querySelectorAll('[class*="quantity"] button, [class*="qty"] button, [data-quantity-selector] button, button[data-increase-quantity], button[data-decrease-quantity]').forEach(function (btn) {
      if (btn.getAttribute('aria-label') || btn.getAttribute('aria-labelledby')) return;
      var label = clean(btn.textContent);
      var cls = btn.className && btn.className.toString ? btn.className.toString() : '';
      if (btn.hasAttribute('data-increase-quantity') || label === '+' || (label === '' && /plus|increase|increment|up/i.test(cls))) {
        btn.setAttribute('aria-label', text.increase || 'Increase quantity');
      } else if (btn.hasAttribute('data-decrease-quantity') || label === '-' || label === '\u2212' || (label === '' && /minus|decrease|decrement|down/i.test(cls))) {
        btn.setAttribute('aria-label', text.decrease || 'Decrease quantity');
      }
    });
  }

  /* 2. Add to cart announcement */
  var pendingTitle = null;
  document.addEventListener('theme:cart:popdown', function (event) {
    var variant = event.detail && event.detail.variant;
    pendingTitle = variant ? clean(variant.name || variant.product_title || variant.title || '') : '';
    var once = function () {
      document.removeEventListener('theme:cart:change', once);
      var message = (text.added || 'Added to cart') + (pendingTitle ? ': ' + pendingTitle : '');
      // After the drawer has opened and moved focus to its close button.
      announce(message, 900);
    };
    document.addEventListener('theme:cart:change', once);
  });

  /* Keep up with content rendered later (Kaching, cart drawer, quick view) */
  var queued = false;
  function scan() {
    queued = false;
    labelKaching(document);
    labelQuantity(document);
  }
  function queue() {
    if (queued) return;
    queued = true;
    setTimeout(scan, 150);
  }

  function start() {
    region();
    scan();
    new MutationObserver(queue).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
